import { render, staticRenderFns } from "./apartment-location-faq.vue?vue&type=template&id=5393b996&scoped=true&"
import script from "./apartment-location-faq.ts?vue&type=script&lang=ts&"
export * from "./apartment-location-faq.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-location-faq.scss?vue&type=style&index=0&id=5393b996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5393b996",
  null
  
)

export default component.exports